import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tab } from './tab.model';

/**
 * Die Tabs-Komponente ist eine allgemeine Komponente zur Darstellung von Tabs.
 *
 * @author jngi
 * @author thm
 */

@Component({
    selector: 'common-tabs',
    templateUrl: './tabs.component.html'
})
export class TabsComponent {

    @Input() extraClass: string;
    @Output() clickEvt: EventEmitter<any> = new EventEmitter();

    @Input() tabs: Tab[] = [];

    private activeTab: Tab;

    selectTab(tab: Tab) {
        this.tabs.forEach((tab) => {
            tab.active = false;
        });

        tab.active = true;
        this.activeTab = tab;
        this.clickEvt.emit(tab);
    }

    // xsmall and small variants displays their content separately (active and inactive <li>s )
    get inactiveEntries() {
        return this.tabs && this.tabs.filter(e => !e.active);
    }

    /**
     * returns a single Tab which is active right now. (Position 1 in the visible list)
     * @returns {Tab}
     */
    get activeEntry() {
        return this.activeTab || this.tabs && this.tabs.filter(e => e.active)[0];
    }
}
